import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';

import { BetBuilderMarket, EventModel } from '@frontend/sports/betting-offer/feature/model';
import { FontResizerComponent } from '@frontend/sports/common/core/feature/font-resizer';
import { NativePriceFormatterPipe } from '@frontend/sports/odds/feature/native-price';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { BetBuilderEditPrecreatedBABButtonComponent } from '../bet-builder/components/button/bet-builder-edit-precreated-bab-button.component';
import { BetBuilderPickComponent } from '../option-pick/betbuilder-pick.component';

@Component({
    selector: 'ms-precreated-option',
    templateUrl: './precreated-option.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        BetBuilderEditPrecreatedBABButtonComponent,
        BetBuilderPickComponent,
        FontResizerComponent,
        NativePriceFormatterPipe,
        IconCustomComponent,
    ],
})
export class PrecreatedOptionComponent implements OnInit {
    @Input() event: EventModel;
    @Input() fixtureId: string;
    @Input() market: BetBuilderMarket;
    @Input() contentPosition: number;
    @Input() trackingModuleType = '';
    @Input() showEditButton? = true;
    @Input() betDetails?: string;

    @HostBinding('class') className = 'betbuilder-market-card';
    marketLegs: string[];
    pickTrackingSource = 'eventdetails/build a bet market pod/betbuilder/';

    ngOnInit(): void {
        this.marketLegs = this.mapLegs();
        this.pickTrackingSource = this.pickTrackingSource + this.market.themedTab + '/precreated';
    }

    private mapLegs(): string[] {
        return this.market.name.split(';');
    }
}
